import PageLayout from "../../components/feature/PageLayout";
import InfoPageHero from "../../components/feature/InfoPageHero";
import InfoPageFooter from "../../components/feature/InfoPageFooter";
import ComparisonSection from "./components/ComparisonSection";
import TipsSection from "./components/TipsSection";
import { heroData } from "../../mocks/baggageData";

export default function Baggage() {
  return (
    <PageLayout>
      <InfoPageHero
        label="BAGGAGE"
        title={heroData.title}
        subtitle={heroData.subtitle}
        image={heroData.image}
        alt="機内への持ち込み制限のある手荷物"
      />
      <ComparisonSection />
      <TipsSection />
      <InfoPageFooter />
    </PageLayout>
  );
}
